import { ToolRow } from "@/components/portal/tool-row";
import { Eyebrow } from "./_primitives/eyebrow";

type Tool = {
  toolSetupId: string;
  name: string;
  note: string;
  link: string;
  ownerEmail: string;
  state: "pending" | "configured";
  lastAskedAt: string | null;
};

type Props = {
  tools: Tool[];
  readOnly: boolean;
  onToggle: (toolSetupId: string) => void;
  onAskOwner: (toolSetupId: string) => void;
  askingId: string | null;
};

export function SetupChecklist({ tools, readOnly, onToggle, onAskOwner, askingId }: Props) {
  if (tools.length === 0) {
    return (
      <div className="rounded-lg border bg-muted/20 p-6 text-center text-sm text-muted-foreground">
        Nenhuma ferramenta atribuída.
      </div>
    );
  }
  const pending = tools.filter((t) => t.state === "pending");
  const configured = tools.filter((t) => t.state === "configured");
  return (
    <div className="space-y-8">
      {pending.length > 0 && (
        <section className="space-y-3">
          <Eyebrow className="text-muted-foreground">A configurar · {pending.length}</Eyebrow>
          <div className="space-y-2">
            {pending.map((tool) => (
              <ToolRow
                key={tool.toolSetupId}
                tool={tool}
                readOnly={readOnly}
                onToggle={onToggle}
                onAskOwner={onAskOwner}
                asking={askingId === tool.toolSetupId}
              />
            ))}
          </div>
        </section>
      )}
      {configured.length > 0 && (
        <section className="space-y-3">
          <Eyebrow className="text-muted-foreground">Configuradas · {configured.length}</Eyebrow>
          <div className="space-y-2">
            {configured.map((tool) => (
              <ToolRow
                key={tool.toolSetupId}
                tool={tool}
                readOnly={readOnly}
                onToggle={onToggle}
                onAskOwner={onAskOwner}
                asking={askingId === tool.toolSetupId}
              />
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
